import React, { useEffect, useMemo, useState } from "react";

import classNames from "classnames";
import { decode } from "html-entities";
import PropTypes from "prop-types";

import MessageLinkPreview from "./MessageLinkPreview";

import matchAllUrlsRegex from "../../../utils/regex/common";
import Markdown from "../../markdown/index";

function MessageText({ content, author, first, last, status }) {
    const [validContentLinks, setValidContentLinks] = useState(null);

    const checkLinksInMessageContent = useMemo(
        () =>
            typeof content === "string"
                ? content.match(matchAllUrlsRegex)
                : content.text.match(matchAllUrlsRegex),
        [content]
    );

    useEffect(() => {
        if (checkLinksInMessageContent)
            setValidContentLinks(checkLinksInMessageContent);
    }, [checkLinksInMessageContent]);

    const contentToDisplay =
        typeof content === "string" ? content : content.text;

    return (
        <div
            className={classNames("ek-chat__message--text", {
                "ek-chat__message--text-first":
                    first &&
                    (!last ||
                        author.type === "visitor" ||
                        (author.type !== "visitor" && last)),
                "ek-chat__message--text-last": last && !first,
                "ek-chat__message--text-loading": !!status?.loading,
                "ek-chat__message--text-error": !!status?.error,
            })}
        >
            <MessageLinkPreview validContentLinks={validContentLinks} />
            <Markdown content={decode(contentToDisplay.trim())} />
        </div>
    );
}

MessageText.propTypes = {
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
    author: PropTypes.shape({
        _id: PropTypes.string,
        type: PropTypes.oneOf(["operator", "supervisor", "visitor", "agent"]),
        name: PropTypes.string,
    }),
    status: PropTypes.shape({
        loading: PropTypes.bool,
        error: PropTypes.bool,
    }),
    first: PropTypes.bool,
    last: PropTypes.bool,
};

MessageText.defaultProps = {
    content: "",
    author: {},
    status: {},
    first: false,
    last: false,
};

export default MessageText;
